var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{staticClass:"u-b1",attrs:{"disabled":_vm.offerHasErrors,"data-test":"offer-download","icon":"mail","type":"default"},on:{"click":_vm.onSendPDF}},[_vm._v(" "+_vm._s(_vm.$t('Pošalji PDF'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }